import { useEffect, useRef, useState } from 'react';

/**
 * Cifra care urcă la încărcare și se mută lin la fiecare reîmprospătare
 * (panoul de control, fila șantierului). Se oprește cu „reduce motion”.
 */
const still = () =>
  typeof window !== 'undefined' && window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;

export function useCountUp(target: number, ms = 900): number {
  const [v, setV] = useState(() => (still() ? target : 0));
  const from = useRef(v);
  useEffect(() => {
    if (still()) {
      setV(target);
      from.current = target;
      return;
    }
    const start = performance.now();
    const a = from.current;
    let raf = 0;
    const tick = (now: number) => {
      const t = Math.min(1, (now - start) / ms);
      const e = 1 - (1 - t) ** 3;
      const x = a + (target - a) * e;
      setV(x);
      from.current = x;
      if (t < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [target, ms]);
  return v;
}
